class OutOfStock extends HTMLElement {
  constructor() {
    super();
    this.reserveBtn = this.querySelector(".js-ofs-reserve-btn");
    this.ofsPopup = this.querySelector("ofs-reserve");
    // document.body.appendChild(this.ofsPopup);
    this.reserveBtn.addEventListener(
      "click",
      this.handleReserveClick.bind(this)
    );
  }
  handleReserveClick(event) {
    console.log("LA");
    this.ofsPopup.setAttribute("state", "show");
    console.log(this.ofsPopup);
  }
}

customElements.define("out-of-stock", OutOfStock);

class OfsReserve extends HTMLElement {
  static observedAttributes = ["state"];
  constructor() {
    super();

    this.form = this.querySelector("form");

    this.form.addEventListener("submit", this.handleFormSubmit.bind(this));

    this.overlay = this.querySelector(".overlay");
    this.overlay.addEventListener("click", () => {
      this.setAttribute("state", "hidden");
    });
    this.querySelectorAll(".ofs-reserve__close-btn").forEach((closer) => {
      closer.addEventListener("click", () => {
        this.setAttribute("state", "hidden");
      });
    });

    this.altsSection = this.querySelector(".ofs-reserve__alternatives");
    if (this.altsSection) {
      this.altsSection.classList.add("hidden");
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "state") {
      this.handleStateChange(newValue);
    }
  }
  handleStateChange(value) {
    this.state = value;
  }
  handleFormSubmit(event) {
    event.preventDefault();

    const formData = {};
    this.form.querySelectorAll("input").forEach((input) => {
      formData[input.name] = input.value;
    });

    console.log(formData);
    const formActionUrl = this.form.action;

    fetch(formActionUrl, {
      body: JSON.stringify(formData),
      redirect: "follow",
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "text/plain;charset=utf-8",
      },
    })
      .then(() => {
        this.showSuccessMessage();
      })
      .catch((error) => {
        console.error("Error:", error);
        this.showSuccessMessage();
      });

    this.showSuccessMessage();
  }

  appendAlternativesFromPage() {
    const track = this.querySelector(".ofs-reserve__alts-cards");
    if (!track) return;

    const sourceItems = document.querySelectorAll(
      "best-alternatives .alt-product-card"
    );
    Array.from(sourceItems)
      .slice(0, 3)
      .forEach((item) => {
        const clone = item.cloneNode(true);

        const titleEl = clone.querySelector(".product-title");
        if (titleEl) {
          const MAX_CHARS = 45;
          let txt = titleEl.textContent.trim();

          if (txt.length > MAX_CHARS) {
            titleEl.textContent = txt.slice(0, MAX_CHARS - 1) + "…";
          }
        }

        track.appendChild(clone);
      });
  }

  initAltSlider() {
    const track = this.querySelector(".ofs-reserve__alts-cards");
    const prev = this.querySelector(".ofs-alts-prev");
    const next = this.querySelector(".ofs-alts-next");
    if (!track || !prev || !next) return;
    const updateButtons = () => {
      prev.disabled = track.scrollLeft === 0;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth;
    };

    prev.addEventListener("click", () => {
      track.scrollBy({ left: -track.clientWidth * 0.8, behavior: "smooth" });
    });
    next.addEventListener("click", () => {
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: "smooth" });
    });

    track.addEventListener("scroll", () => {
      window.requestAnimationFrame(updateButtons);
    });

    updateButtons();
  }

  showSuccessMessage() {
    this.querySelector(".ofs-reserve__title").innerHTML =
      "Succesful submission!";
    this.querySelector(".ofs-reserve__desc").innerHTML =
      "Thank you for your reservation, our team will reach out to you once we have received the product.";
    this.form.style.display = "none";
    if (!this.querySelector(".ofs-reserve--sucess")) {
      const closeBtn = document.createElement("button");
      closeBtn.classList.add("ofs-reserve--sucess");
      closeBtn.innerHTML = "Continue shopping";
      this.querySelector(".ofs-reserve__inner").appendChild(closeBtn);
      closeBtn.addEventListener("click", () => {
        this.setAttribute("state", "hidden");
      });
    }

    const successImg = this.querySelector(".ofs-reserve__success-img");
    if (successImg) successImg.style.display = "block";

    if (this.altsSection) {
      this.altsSection.classList.remove("hidden");
    }

    this.appendAlternativesFromPage();
    this.initAltSlider();
  }
}
customElements.define("ofs-reserve", OfsReserve);

class BestAlternatives extends HTMLElement {
  constructor() {
    super();
    this.alternativesNum = this.querySelector(".alternatives-num");
    this.alternativesBtn = this.querySelector(".js-ofs-best-alternatives");
    this.productsTemplate = this.querySelector("#alt-product-template");
    this.productsContainer = this.querySelector(
      "best-alternatives .product-cards-container"
    );
    this.custmerType = document.body.classList.contains(
      "customer-type--consumer"
    )
      ? "Consumer"
      : "Wholesaler";
    this.url = `https://secondshop.ca/collections/all?filter.p.product_type=${this.dataset.productType}&filter.p.m.custom.width=${this.dataset.productWidth}&filter.v.availability=1&filter.p.m.display.status=Both&filter.p.m.display.status=${this.custmerType}&sort_by=manual`;

    this.alternativesBtn.addEventListener(
      "click",
      this.handleAlternativesClick.bind(this)
    );
  }
  connectedCallback() {
    this.getAlternativeCollection();
    this.getRecommendedProduct();
  }

  async getRecommendedProduct() {
    let foundAlternatives =
      this.dataset.foundAlternatives?.split(",")?.map((id) => id.trim()) || [];
    // Calculate how many products still need to be loaded
    let maxProducts =
      3 -
      this.querySelectorAll(".product-cards-container .alt-product-link")
        .length;

    if (maxProducts <= 0) {
      return;
    }

    const customFilters = this.dataset.customFilters
      ?.split(",")
      .filter((el) => el);

    console.log("customFilters: ", customFilters);

    // Setup URL filters based on dataset values
    const urlFilters = {
      subcategory: `&filter.p.m.custom.subcategory=${this.dataset.subcategory}`,
      productWidth: `&filter.p.m.custom.width=${this.dataset.productWidth}`,
      customFilters,
    };

    // Helper to construct the base URL; set includeSubcategory to false for fallback
    const buildBaseURL = ({
      includeSubcategory,
      includeCustomFilters,
      includeWidth,
    }) => {
      let url = `https://secondshop.ca/collections/all?filter.p.product_type=${this.dataset.productType}`;
      if (includeWidth) {
        url += urlFilters.productWidth;
      }
      if (includeSubcategory) {
        url += urlFilters.subcategory;
      }
      if (includeCustomFilters) {
        url += urlFilters.customFilters;
      }
      url += `&filter.v.availability=1&filter.p.m.display.status=Both&filter.p.m.display.status=${this.custmerType}&sort_by=manual`;
      return url;
    };

    // Helper that encapsulates fetching, parsing, selecting, and rendering products.
    // It returns the remaining number of products needed.
    const fetchAndRender = async (url, count) => {
      console.log("foundAlternatives: ", foundAlternatives);
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const htmlText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, "text/html");
        const products = Array.from(
          doc.querySelectorAll("#product-grid .grid__item")
        )
          .filter(
            (product) =>
              !foundAlternatives.includes(
                product.querySelector("div[data-product-id]")?.dataset.productId
              ) && !product.querySelector(".is-phantom-product")
          )
          .splice(0, count);
        console.log(products);
        this.renderProducts({ productsToRender: products, maxProducts: count });
        foundAlternatives.push(
          ...products.map(
            (product) =>
              product.querySelector("div[data-product-id]")?.dataset.productId
          )
        );
        console.log("FOUND ALTERNATIVES: ", foundAlternatives);
        return count - products.length;
      } catch (error) {
        throw new Error("Error fetching or parsing HTML: " + error);
      }
    };

    // First attempt: include the subcategory filter.
    let url = buildBaseURL({
      includeSubcategory: true,
      includeCustomFilters: true,
      includeWidth: true,
    });
    maxProducts = await fetchAndRender(url, maxProducts);

    // If we still need more products, try without the custom filters filter.
    if (maxProducts > 0) {
      url = buildBaseURL({
        includeSubcategory: true,
        includeCustomFilters: false,
        includeWidth: true,
      });
      maxProducts = await fetchAndRender(url, maxProducts);
    }

    // If we still need more products, try without the subcategory filter.
    if (maxProducts > 0) {
      url = buildBaseURL({
        includeSubcategory: false,
        includeCustomFilters: false,
        includeWidth: true,
      });
      maxProducts = await fetchAndRender(url, maxProducts);
    }
    // If we still need more products, try without the subcategory filter.
    if (maxProducts > 0) {
      url = buildBaseURL({
        includeSubcategory: false,
        includeCustomFilters: false,
        includeWidth: false,
      });
      maxProducts = await fetchAndRender(url, maxProducts);
    }
  }

  renderProducts({ productsToRender, maxProducts }) {
    productsToRender.forEach((product, index) => {
      const productClone = this.productsTemplate.content.cloneNode(true);
      productClone.querySelector(".product-title").textContent =
        product.querySelector(".card__heading .full-unstyled-link").textContent;
      productClone.querySelector(".regular-price").textContent =
        product.querySelector(".price-saving .new-price").textContent;
      productClone.querySelector(".alt-product-link").href =
        product.querySelector(".card__heading  .full-unstyled-link").href;

      const oldPriceText =
        Number(
          product
            .querySelector(".inner-price-container .old-price")
            ?.textContent.replace(/[^0-9.]/g, "")
        ) || "0";
      const newPriceText =
        Number(
          product
            .querySelector(".price-saving .new-price")
            ?.textContent.replace(/[^0-9.]/g, "")
        ) || "0";
      const savings = Number(
        (parseFloat(oldPriceText) - parseFloat(newPriceText)).toFixed(2)
      ).toLocaleString();
      productClone.querySelector(".save-price").textContent = savings
        ? `$${savings}`
        : "";
      productClone.querySelector(".product-image").src = product.querySelector(
        ".card__media .media img"
      ).src;
      productClone.querySelector(".product-image").alt = product.querySelector(
        ".card__media .media img"
      ).alt;
      //getting the tags
      productClone.querySelector(".tags .last-year-model-tag").style.display =
        "none";

      const template = product.querySelector("template");
      if (template) {
        const clone = template.content.cloneNode(true);

        productClone.querySelector(".tags").appendChild(clone);
      }
      this.productsContainer.appendChild(productClone);
    });
  }

  async getAlternativeCollection() {
    console.log(this.url);
    try {
      const response = await fetch(this.url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, "text/html");

      const productGridCount = doc.querySelectorAll(
        "#product-grid .grid__item"
      ).length;

      const itemsCount = Number(productGridCount);
      if (itemsCount <= 1) {
        this.url = `https://secondshop.ca/collections/all?filter.p.product_type=${this.dataset.productType}&filter.v.availability=1&filter.p.m.display.status=Both&filter.p.m.display.status=${this.custmerType}&sort_by=manual`;
        const response = await fetch(this.url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const htmlText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, "text/html");

        const productGridCount = doc.querySelectorAll(
          "#product-grid .grid__item"
        ).length;

        const itemsCount = Number(productGridCount);
        if (itemsCount > 1) {
          this.alternativesNum.innerHTML = `${itemsCount} related products`;
          this.classList.remove("hidden");
        }
      } else {
        this.alternativesNum.innerHTML = `${itemsCount} related products`;
        this.classList.remove("hidden");
      }
    } catch (error) {
      throw new Error("Error fetching or parsing HTML: " + error);
    }
  }
  handleAlternativesClick(event) {
    window.location.href = this.url;
  }
}

customElements.define("best-alternatives", BestAlternatives);

function reserveOutOfStock() {
  document.querySelector(".js-ofs-reserve-btn")?.click();
}
